"use strict";

Shopify.theme.jsFeaturedCollection = {
  init: function init($section) {
    

    if($('#template-404').length>0){
      let section_id = $section.attr('id');

        let gender = "all";
        if (window.Cookies.get('gender') == 'women' ) {
          gender = "woman";
        }
        else if (window.Cookies.get('gender') == 'men' ) {
          gender = "men";
        }
		let id_str = `shopify-section-${gender}-landing-featured-collection`;
      if(gender == 'all'){
        id_str = "shopify-section-index__featured-collection-tab";
      }

        if(section_id != id_str){
          $( `#${section_id}` ).remove();
          return false;
        }
        
      
    }
    
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(
      this,
      Shopify.theme.getSectionData($section)
    );

    if (
      this.enable_masonry_layout &&
      !this.align_height &&
      this.collection_style == "grid"
    ) {
      Shopify.theme.applyMasonry();
    }

    var data = {
      products_men: [],
      products_women: [],
      products_accessory: [],
    };

    if (this.collection_style == "slider") {
      this.createSlider();
    }

    tinybind.bind($(".slider-gallery"), {
      data: data,
    });

    var stoped = 0;
    var stoped_2 = 0;
    var accessory_counter = 0;

    if($section && $section.length > 0) {
      const container = $section[0];

      if(window.innerWidth < 749) {
          container.querySelectorAll('.thumbnail-sticker').forEach(sticker => {
              let pseudo = window.getComputedStyle(sticker, ':after');
              if(pseudo.getPropertyValue("content") && pseudo.getPropertyValue("content") != "none") {
                  if(pseudo.getPropertyValue("content").length > 10) {
                      sticker.parentElement.style.top = '20px';
                      sticker.parentElement.style.right = '-30px';
                  }else if(pseudo.getPropertyValue("content").length > 7) {
                      sticker.parentElement.style.top = '16px';
                      sticker.parentElement.style.right = '-25px';
                  }
              }
          })
      }

      container.querySelectorAll('.gallery-cell').forEach(a => {
        window.stickerRemove && window.stickerRemove(a);
      })
    }

    this.men_products = this.men_products || [];
    if ($('#template-404').length < 1) {
      this.men_products.forEach(function (element, index, array) {

        $.ajax({
          dataType: "text",
          url: "https://www.gluestore.com.au/products/" + element + "?view=json",
          success: function (product) {

            product = JSON.parse(product);
            data.products_men.push(product);
            stoped++;
            if (stoped === array.length) {
              reinitSlider();
            }

          },
        });
      });
    }

    this.women_products = this.women_products || [];
    if ($('#template-404').length < 1) {
    this.women_products.forEach(function (element, index, array) {
      $.ajax({
        dataType: "text",
        url: "https://www.gluestore.com.au/products/" + element + "?view=json",
        success: function (product) {
          product = JSON.parse(product);
          data.products_women.push(product);
          stoped_2++;
          if (stoped_2 === array.length) {
            reinitSlider();
          }
        },
      });
    });
  }

    this.accessory_products = this.accessory_products || [];
    if ($('#template-404').length < 1) {
    this.accessory_products.forEach(function (element, index, array) {
      $.ajax({
        dataType: "text",
        url: "/products/" + element + "?view=json",
        success: function (product) {
          product = JSON.parse(product);
          data.products_accessory.push(product);
          accessory_counter++;
          if (accessory_counter === array.length) {
            reinitSlider();
          }
        },
      });
    });
    }

    function reinitSlider() {
      var featuredCollectionSlider = $(
        ".featured-collection.layout--slider .slider-gallery"
      );

      featuredCollectionSlider.each(function () {
        featuredCollectionSlider.flickity("reloadCells");
      });
    }

    // toggle tab
    $section.on("click", ".featured-collection-nav-tab", function (e) {
      var elem = $(this);
      elem
        .addClass("active")
        .siblings(".featured-collection-nav-tab")
        .removeClass("active");

      $section
        .find("." + elem.attr("data-class"))
        .addClass("active")
        .siblings(".featured-collection-tab")
        .removeClass("active");
    });
  },
  createSlider: function createSlider() {
    var featuredCollectionSlider = $(
      ".featured-collection.layout--slider .slider-gallery"
    );
    var slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
    };

    featuredCollectionSlider.each(function () {
      var selector = "#" + $(this).attr("id");

      var slider = $(this).flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: "left",
        pageDots: false,
        contain: true,
        prevNextButtons:
          slideData.products_limit > slideData.products_per_slide
            ? true
            : false,
        initialIndex: 0,
        // arrowShape: arrowShape,
        on: {
          ready: function ready() {
            // Reset layout to avoid collapsing issues
            setTimeout(function () {
              $(featuredCollectionSlider).flickity("resize");
            }, 500);
          },
        },
      });
      theme.utils.fixFlikityPrevNextButton(slider, selector);


    });
  },
  unload: function unload($section) {
    var $slider = $section.find(".flickity-enabled");
    $slider.flickity("destroy");
  },
};